import { WeatherWidget, WeatherWidgetSkeleton } from "@/components/WeatherWidget";
import { MoonWidget, MoonWidgetSkeleton } from "@/components/MoonWidget";
import { ISSWidget, ISSWidgetSkeleton } from "@/components/ISSWidget";

export const QuickStatsRow = ({ loading, weather, moon, iss }) => (
  <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
    {loading ? (
      <>
        <WeatherWidgetSkeleton />
        <MoonWidgetSkeleton />
        <ISSWidgetSkeleton />
      </>
    ) : (
      <>
        <WeatherWidget weather={weather} compact />
        <MoonWidget moon={moon} compact />
        <ISSWidget iss={iss} compact />
      </>
    )}
  </section>
);
